import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Stack, Heading, Bleed, Box } from "braid-design-system";
import { useMemo, useCallback } from "react";
import { useJobDetailsViewContext, useAnalyticsHandlers } from "../CompanyProfile/CompanyProfile.mjs";
import { getPaddingX } from "../JDVLayout/JDVLayout.mjs";
import { translations } from "../../../components/CompetitiveJobs/.vocab/index.mjs";
import { CompetitiveJobCard } from "./CompetitiveJobCard.mjs";
import { horizontalScrollOnTablet } from "./CompetitiveJobs.css.mjs";
const CompetitiveJobs = ({
  jobs,
  onAnalyticsEvent = () => {
  }
}) => {
  const isEnableHorizontalScroll = jobs.length === 3;
  const { t } = useTranslations(translations);
  const { embedded } = useJobDetailsViewContext();
  const jdvPaddingXForTablet = useMemo(() => {
    const jdvPaddingX = getPaddingX({
      embedded
    });
    return typeof jdvPaddingX === "object" ? jdvPaddingX.tablet : jdvPaddingX || "none";
  }, [embedded]);
  const analytics = useAnalyticsHandlers(onAnalyticsEvent);
  const numberOfRecommendedJobsDisplayed = jobs.length;
  const { job } = useJobDetailsViewContext();
  const { id, isExpired } = job;
  const trackCallback = useCallback(() => {
    if (id) {
      analytics.onRecommendedJobsViewed({
        jobId: id,
        numberOfRecommendedJobsDisplayed,
        jobStatus: isExpired ? "Expired" : "Active"
      });
    }
  }, [analytics, id, isExpired, numberOfRecommendedJobsDisplayed]);
  const [firstJob, ...restJobs] = jobs;
  return /* @__PURE__ */ jsxs(Stack, { space: "large", data: { testid: "competitive-jobs" }, children: [
    /* @__PURE__ */ jsx(Heading, { level: "4", children: t("Featured jobs", { jobCount: jobs.length }) }),
    /* @__PURE__ */ jsx(
      Bleed,
      {
        horizontal: {
          mobile: "none",
          tablet: isEnableHorizontalScroll ? jdvPaddingXForTablet : "none",
          desktop: "none"
        },
        children: /* @__PURE__ */ jsxs(
          Box,
          {
            display: "flex",
            gap: "small",
            flexDirection: { mobile: "column", tablet: "row" },
            width: "full",
            className: {
              [horizontalScrollOnTablet]: isEnableHorizontalScroll
            },
            paddingLeft: {
              tablet: isEnableHorizontalScroll ? jdvPaddingXForTablet : "none",
              desktop: "none"
            },
            children: [
              /* @__PURE__ */ jsx(
                CompetitiveJobCard,
                {
                  id: firstJob.id,
                  pos: 1,
                  title: firstJob.title,
                  advertiserName: firstJob.company.name,
                  locationLabel: firstJob.location,
                  listingDateLabel: firstJob.postedDateFormatted,
                  srcLogo: firstJob.srcLogo,
                  isEnableHorizontalScroll,
                  wrapperPaddingRight: {
                    tablet: isEnableHorizontalScroll && jobs.length - 1 === 0 ? jdvPaddingXForTablet : "none",
                    desktop: "none"
                  },
                  trackCallback
                }
              ),
              restJobs.map((props, index) => /* @__PURE__ */ jsx(
                CompetitiveJobCard,
                {
                  isEnableHorizontalScroll,
                  wrapperPaddingRight: {
                    tablet: isEnableHorizontalScroll && index === jobs.length - 1 ? jdvPaddingXForTablet : "none",
                    desktop: "none"
                  },
                  id: props.id,
                  pos: index + 1,
                  title: props.title,
                  advertiserName: props.company.name,
                  locationLabel: props.location,
                  listingDateLabel: props.postedDateFormatted,
                  srcLogo: props.srcLogo
                },
                index
              ))
            ]
          }
        )
      }
    )
  ] });
};
export {
  CompetitiveJobs
};
